module.exports = __webpack_public_path__ + "media/components/videos_internal/bluezones-tour-482aaf63b8d6aa0e3657de77d5fa85ba.jpg";